/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-10 14:08:07
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-07-14 11:57:55
 * @Description: file content
 */
window.comreq = {
  /**
   * 
   * @param {*} callback 
   * @param {*} openid
   */
  fansInfo: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbUserAction/fansInfo",
          "requestParam": {
            obj: {
              openid: openid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("/hb/HbUserAction/fansInfo", data);
        if (callback) callback(data);
      }
    });
  },
  getAgentInfo: function (callback) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "dhyxcrm",
          "requestParam": {
            "module": "yx", "oper": "getAgentInfo"
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("getAgentInfo", data);
        if (callback) callback(data);
      }
    });
  },
  /**
   * 
   * @param {*} callback 
   * @param {*} pars {openid}
   */
  getUserInfo: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/global/User/getUserInfo",
          "requestParam": {
            openid: openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("/global/User/getUserInfo", data);
        if (callback) callback(data);
      }
    });
  },
  getUserInfo2: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/global/User/getUserInfo2",
          "requestParam": {
            openid: openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("/global/User/getUserInfo2", data);
        if (callback) callback(data);
      }
    });
  },
  getUserIntegralInfo: function (callback) {
    var count = 0;
    var agentInfo = null, userInfo = null, userProjects = null;
    function postOver() {
      count++;
      if (count == 3) {
        let userIntegralInfo = {
          agentInfo: agentInfo,
          userInfo: userInfo,
          isSale: false,//是否注册为销售且审核通过
          saleStatusMsg: "",//销售注册状态
          isAgent: false,//是否注册为中介且审核通过
          agentStatusMsg: "",//中介注册状态
          ui: {
            headimg: (userInfo.user && userInfo.user.headimgurl) ? userInfo.user.headimgurl : 'https://assets.wxmp.ruthus.com/rushixcx/default-head.png',//用户头像。优先次序：上传头像>微信头像
            name: (agentInfo ? agentInfo.agentname : '') || (userInfo.user ? userInfo.user.nickname : ''),//用户姓名。优先次序：注册姓名>微信昵称
          }
        }
        if (userInfo && userInfo.user && userInfo.role && userInfo.role.length) {
          // 审核通过
          // 销售判断，从是文章所属公众号的销售 改成 是文章所属项目的销售
          // if (userProjects) {
          //   if (userProjects.some(item => item.projectid == parseInt(myPageData.Pid))) {
          //     userIntegralInfo.isSale = true;
          //   }
          // }
          userIntegralInfo.isSale = true;
        } else if (userInfo && userInfo.user && userInfo.user.cardno) {
          // 请联系管理员，分配项目！
          userIntegralInfo.saleStatusMsg = "请联系管理员，分配项目！";
        }

        if (agentInfo && agentInfo.status == 0) {
          userIntegralInfo.agentStatusMsg = "审核失败";
        } else if (agentInfo && agentInfo.status == 1) {
          userIntegralInfo.agentStatusMsg = "审核中";
        } else if (agentInfo && agentInfo.status == 2) {
          // 审核通过
          userIntegralInfo.isAgent = true;
          // 如果是员工
          if (agentInfo.authtype == 4) {
            userIntegralInfo.isAgentType4 = true;
          }
        }
        console.log("userIntegralInfo", userIntegralInfo);
        if (callback) callback(userIntegralInfo);
      }
    }
    this.getAgentInfo(function (data) {
      agentInfo = data.obj;
      postOver();
    })
    this.getUserInfo(function (data) {
      userInfo = data.obj;
      postOver();
    }, myTemp.openid)

    this.getSalerListprojects(function (res) {
      if (res.obj) {
        userProjects = res.obj;
      }
      postOver();
    }, myTemp.openid)
  },
  updatePageUserSetting: function (callback, cardhidden) {
    let postObj = {
      pageid: parseInt(myPageData.PageId),
      openid: myTemp.openid,
      cardhidden: cardhidden
    }

    $.ajax({
      type: "POST",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          openid: myTemp.openid,
          passport: myTemp.openid,
          vericode: '',
          url: location.href,
          action: '/hb/HbH5Action/updatePageUserSetting',
          requestParam: {
            obj: postObj
          }
        })
      },
      success: function (data) {
        if (callback) callback(data);
      }
    });
  },
  getSalerQrcode: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "dhyxcrm",
          "requestParam": {
            "module": "projectsaler", "oper": "listprojects",
            openid, openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("saler qrcode", data);
        if (callback) callback(data);
      }
    });
  },
  getAgentScribeQR: function (callback) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "dhyxcrm",
          "requestParam": {
            "module": "yx", "oper": "getAgentScribeQR",
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        console.log("saler qrcode", data);
        if (callback) callback(data);
      }
    });
  },
  getUserUpFans() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx,
        data: {
          j: JSON.stringify({
            "action": "/hb/HbH5Action/getUserUpFans",
            "requestParam": {
              "pageid": parseInt(myPageData.PageId),
              "refereeopenid": myTemp.refereeopenid
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          if (data && data.obj) {
            resolve(data.obj);
          } else {
            resolve("");
          }
        }
      });
    })
  },
  getReceptionByProject() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx,
        data: {
          j: JSON.stringify({
            "action": "dhyxcrm",
            "requestParam": {
              "module": "projectsaler", "oper": "getReceptionByProject", "projectid": myPageData.Pid
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          if (data && data.obj && data.obj.saleropenid) {
            resolve(data.obj.saleropenid);
          } else {
            resolve("");
          }
        }
      });
    })
  },
  getUiVersion() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx.replace('/wxapi.do', '/m/appExpand/getUiVersion'),
        // url: `http://qmyx.ttrushi.com/qc-webapp/m/appExpand/getUiVersion`,
        // url: `${location.protocol}//${location.host}/qc-webapp/m/appExpand/getUiVersion`,
        async: false,
        headers: {
          openId: myTemp.openid,
          passport: myTemp.passport
        },
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  getMyInviteCount() {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx.replace('/wxapi.do', '/m/saleslead/person/myInviteCount'),
        async: false,
        headers: {
          openId: myTemp.openid,
          passport: myTemp.passport
        },
        data: {},
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 通过服务号openid获取用户绑定的外部帐号信息
   * openid	用户openid	query	true	string
   * accountType	外部绑定的帐号，qywx企业微信	query	false	string
   * @param {*} params 
   */
  getExtUserIdByOpenid(params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx.replace('/wxapi.do', `/m/user/account/${params.accountType}/${params.openid}/${params.projectid}`),
        async: false,
        headers: {
          openId: myTemp.openid,
          passport: myTemp.passport,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        data: {},
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 获取企业微信名片
   * 
   * @param {*} params 
   */
  getCorpUserCard(params) {
    if (params) {
      params.pageId = myPageData.PageId;
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: `${api.wxQcwebapp}/qywx/user/card/get`,
        async: false,
        headers: {
          openId: myTemp.openid,
          passport: myTemp.passport,
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: JSON.stringify(params),
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  base64(imgUrl) {
    return new Promise(function (resolve, reject) {
      $.ajax({
        type: "GET",
        async: false,
        url: api.wx,
        data: {
          j: JSON.stringify({
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "vericode": "",
            "url": location.href,
            "action": "/global/Image/base64",
            "requestParam": {
              "imgUrl": imgUrl
            }
          })
        },
        success: function (data) {
          let imgUrl = "";
          if (data.code == 0) {
            imgUrl = "data:image/jpg;base64," + data.obj;
          }
          resolve(imgUrl)
        }
      });
    });
  },
  getPhotoRewardConfig: function (pageid) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx,
        async: true,
        data: {
          j: JSON.stringify({
            "action": "/hb/HbShowPhotoRewardAction/get",
            "requestParam": {
              obj: {
                pageid: pageid
              }
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  getUsercardConfig: function (pageid, openid) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/card/config`,
        async: true,
        data: {
          pageid, pageid,
          openid: openid
        },
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  submitCardConfig: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/card/config`,
        async: false,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: JSON.stringify(params),
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  getRecommendList: function (pageid) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/recommend/three`,
        async: true,
        data: {
          pageid: pageid
        },
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 
   * 绑定微信openid到企微外部联系人帐号
   * 
   * @param {*} params 
   * accountOrgid 外部绑定的帐号所属组织ID，如企业微信为企业ID query true string
accountType 外部绑定的帐号类型，qywx企业微信 query true string
openid 服务号用户openid query true string
appType 0 自建 1 第三方 query false integer(int32)
cfgId 配置id加密 query false string
extAccount 外部绑定的帐号，如企业微信open_userid query false string
fromAccount 来源帐号（传播者帐号） query false string
state 激励配置编号
   * @returns 
   */
  userAccountBindExternal(params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: api.wx.replace('/wxapi.do', `/m/user/account/bind/external`),
        async: false,
        headers: {
          openId: myTemp.openid,
          passport: myTemp.passport,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        data: params,
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  // 获取分享海报背景图
  getBgPoster: function (pageid) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/random/bgPoster`,
        async: true,
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  apiUpdateMyFans: function (openid, type) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: api.wx,
        async: false,
        data: {
          j: JSON.stringify({
            "action": "/hb/HbUserAction/updateMyFans",
            "requestParam": {
              obj: {
                openid: openid,
                cardtype: type
              }
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {
          console.log("/hb/HbUserAction/updateMyFans", data);
          resolve(data);
        }
      });
    })
  },
  // 投诉接口
  addComplain(params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/addComplain`,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        async: true,
        data: JSON.stringify(params),
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 获取客服账号专属链接
   * corpId	corpId	query	false	string
   * kfId	kfId	query	false	string
   * userId	userId	query	false	string
   * @param {*} params 
   * @returns 
   */
  getServicerUrl: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/qywx/kfAccount/getServicerUrl`,
        async: false,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: params,
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 
   * @param {*} params 
   * @returns 
   */
  getAgentInfoByOpenid: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/open/dh/agent/getAgentInfo/${params.openid}`,
        async: false,
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
  /**
   * 根据appid和pageid生成临时关注二维码
   * appid	公众号Id	query	true	string
    openid	openid	query	true	string
    pageid	pageid	query	true	integer(int32)
   * @param {*} params 
   * @returns 
   */
  getTemporaryQRCode: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/page/getTemporaryQRCode`,
        data: params,
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        async: false,
        success: function (res) {
          resolve(res)
        }
      });
    })
  },
  /**
   * 判断是否分享过对应文章
   * pageid	pageid	query	true	integer(int32)
      refereeopenid	分享者openid	query	true	string
   * @param {*} params 
   * @returns 
   */
  judgementShare: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/share/judgementShare`,
        data: params,
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        async: false,
        success: function (res) {
          resolve(res)
        }
      });
    })
  },
  // 获取用户的隐私协议展示的记录
  getPrivacyPolicyBrowseLog: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "GET",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/m/page/get/privacy/policy/browse/log`,
        async: false,
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          openId: myTemp.openid,
          passport: myTemp.passport
        },
        data: params,
        success: function (res) {
          resolve(res)
        }
      });
    })
  },
  // 获取用户的隐私协议展示的记录
  savePrivacyPolicyBrowseLog: function (params) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: `${location.protocol}//${cfg.apihost}/qc-webapp/m/page/save/privacy/policy/browse/log`,
        async: false,
        headers: {
          'content-type': 'application/json',
          openId: myTemp.openid,
          passport: myTemp.passport
        },
        data: JSON.stringify(params),
        success: function (res) {
          resolve(res)
        }
      });
    })
  },
  getSalerListprojects: function (callback, openid) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "dhyxcrm",
          "requestParam": {
            "module": "yx", "oper": "listAssignedProjects",
            saleropenid: openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (callback) callback(data);
      }
    });
  },
  // bizType 业务类型：1-浏览 2-分享 3-留电	
  qywxGroupMsg(bizType) {
    return new Promise((resolve, reject) => {
      let params = {
        "batchId": myTemp.batchId,
        "bizType": bizType,
        "corpId": myTemp.corpId,
        "internalUserId": myTemp.qwUserId,
        "pageId": myPageData.PageId
      }
      $.ajax({
        type: "POST",
        url: api.wx.replace('/wxapi.do', '/m/qywx/group/msg/link/statistics'),
        async: false,
        headers: {
          'content-type': 'application/json',
          openId: myTemp.openid,
          passport: myTemp.passport
        },
        data: JSON.stringify(params),
        success: function (data) {
          resolve(data)
        }
      });
    })
  },
}
